import { ColorPickerDesignTokens } from '@primeuix/themes/types/colorpicker';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/colorpicker/index.ts
const cp = componentCommon.colorpicker;
const cpCs = componentColorScheme.colorpicker;

export const ColorPickerTelekomDT: ColorPickerDesignTokens = {
  preview: {
    width: t(cp.preview.width),
    height: t(cp.preview.height),
    borderRadius: t(cp.preview.border.radius),
    focusRing: {
      width: t(cp.preview.focus.ring.width),
      color: t(cp.preview.focus.ring.color),
      offset: t(cp.preview.focus.ring.offset),
    },
  },
  panel: {
    borderRadius: t(cp.panel.border.radius),
    background: t(cpCs.panel.background),
    borderColor: t(cpCs.panel.border.color),
  },
  handle: {
    color: t(cpCs.handle.color),
  },
};
